var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:['profit_item', _vm.profitClass]},[_vm._v("\n    "+_vm._s(_vm.type)+" Profit "),_c('span',[_vm._v(_vm._s(_vm.amountFormatted))])]),_vm._v(" "),(_vm.hint)?_c('p',{staticClass:"profit_hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }